// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Toolbar_toolbar__Mb1GQ","logo":"Toolbar_logo__2qTPX","light":"Toolbar_light__3na5a","logoLeft":"Toolbar_logoLeft__2ci_e","logoRight":"Toolbar_logoRight__1h-bN"};